function SpinLoader({className}){
    return(
        <div className={`${className} rounded-[50%]`} style={{border:'6px solid rgba(43,51,63,.7)'}}>
            <div className="absolute t-0 -m-[6px] w-[inherit] h-[inherit] rounded-[inherit] animate-loader-spin" style={{borderWidth:'inherit', borderColor:'transparent', borderTopColor:'#fff'}}></div>
            <div className="absolute t-0 -m-[6px] w-[inherit] h-[inherit] rounded-[inherit] animate-loader-spin" style={{borderWidth:'inherit', borderColor:'transparent', borderTopColor:'#fff', animationDelay:'.44s'}}></div>
        </div>
    )
}

export default SpinLoader;